/* eslint-disable import/prefer-default-export */
import { FlexDetails } from 'ggApp/types/graphql';

import ActionsTypes from './actionTypes';

interface SubscriptionDataAction {
    type: typeof ActionsTypes.SET_SUBSCRIPTION_DATA;
    payload: FlexDetails;
}

export function setSubscriptionData(subscriptionData: FlexDetails): SubscriptionDataAction {
    return {
        type: ActionsTypes.SET_SUBSCRIPTION_DATA,
        payload: subscriptionData,
    };
}

export type Action = SubscriptionDataAction;
export type ActionCreator = typeof setSubscriptionData;
